<template>
  <div class="row no-gutters justify-content-between">
    <div class="col-md-7" v-bind:class="{ 'col-md-12': isTablet }">
      <div class="content">
        <div class="content__head">
          <div class="tabs">
            <div class="tabs__body">
              <div class="tab">
                <div class="tab__head">
                  <h5>Payment Options</h5>
                </div>
                <div class="box-form text-left">
                  <md-radio
                    v-model="selPaymentMethod"
                    :value="paymentMethods[0].id"
                    v-if="ccTypes.length && selPaymentMethod != 4"
                    >{{ paymentMethods[0].label }}
                    <i v-bind:class="paymentMethods[0].icon"></i
                  ></md-radio>
                  <md-radio
                    v-model="selPaymentMethod"
                    :value="paymentMethods[1].id"
                    v-if="settings && settings.payPal"
                    >{{ paymentMethods[1].label }}
                    <i v-bind:class="paymentMethods[1].icon"></i
                  ></md-radio>
                  <md-radio
                    v-model="selPaymentMethod"
                    :value="paymentMethods[2].id"
                    v-if="settings && settings.payLaterOption"
                    >{{ paymentMethods[2].label }}
                    <i v-bind:class="paymentMethods[2].icon"></i
                  ></md-radio>
                  <md-radio
                    v-model="selPaymentMethod"
                    :value="paymentMethods[3].id"
                    style="display: none"
                    >{{ paymentMethods[3].label }} {{ totalPrice }}
                    <i v-bind:class="paymentMethods[3].icon"></i
                  ></md-radio>
                </div>
              </div>
              <!-- credit card -->
              <div class="tab" v-if="selPaymentMethod === 1">
                <div class="tab__head">
                  <h5>Payment Information</h5>
                </div>
                <!-- /.tab__head -->
                <div class="box-form">
                  <div class="box__content">
                    <div class="form-frame form-frame--alt">
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <label for="field-fname-2" class="form__label"
                            >First Name
                            <span class="err-msg" v-if="errors.ccFirstName"
                              >*Required</span
                            ></label
                          >
                          <input
                            type="text"
                            class="field"
                            id="field-fname-2"
                            placeholder
                            v-model="ccInfo.FirstName"
                            v-bind:class="{ error: errors.ccFirstName }"
                          />
                        </div>
                        <!-- /.form-group -->
                        <div class="form-group col-md-6">
                          <label for="field-lname-2" class="form__label"
                            >Last Name
                            <span class="err-msg" v-if="errors.ccLastName"
                              >*Required</span
                            ></label
                          >
                          <input
                            type="text"
                            class="field"
                            id="field-lname-2"
                            placeholder
                            v-model="ccInfo.LastName"
                            v-bind:class="{ error: errors.ccLastName }"
                          />
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="field-card-1" class="form__label"
                            >Card Number
                            <span class="err-msg" v-if="errors.ccCardNumber"
                              >*Required</span
                            ></label
                          >
                          <input
                            type="text"
                            class="field"
                            id="field-card-1"
                            placeholder
                            v-model="ccInfo.CardNumber"
                            v-bind:class="{ error: errors.ccCardNumber }"
                          />
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->
                      <div class="form-row">
                        <div
                          class="
                            form-group
                            flex-column
                            justify-content-between
                            col-xl-3 col-md-4
                          "
                        >
                          <label
                            for="field-exdate"
                            class="form__label"
                            style="margin-bottom: 9px !important"
                            >Expiration Date (MM/YYYY)
                            <span
                              class="err-msg"
                              v-if="errors.ccExpMonth || errors.ccExpYear"
                              >*Required</span
                            ></label
                          >
                          <div class="sel-wrap">
                            <select
                              v-model="ccInfo.ExpMonth"
                              placeholder="MM"
                              class="select-field"
                              v-bind:class="{ error: errors.ccExpMonth }"
                            >
                              <option
                                v-for="month in months"
                                :key="month"
                                :value="month"
                              >
                                {{ month }}
                              </option>
                            </select>
                          </div>
                          <div class="sel-wrap">
                            <select
                              v-model="ccInfo.ExpYear"
                              placeholder="YYYY"
                              class="select-field"
                              v-bind:class="{ error: errors.ccExpYear }"
                            >
                              <option
                                v-for="year in years"
                                :key="year"
                                :value="year"
                              >
                                {{ year }}
                              </option>
                            </select>
                          </div>
                          <!-- <input
                            type="text"
                            class="field"
                            maxlength='7'
                            placeholder="MM/YY"
                            v-model="ccInfo.ExpMonth"
                            v-bind:class="{ error: errors.ccExpMonth }"
                          /> -->
                        </div>
                        <!-- /.form-group -->
                        <div
                          class="
                            form-group
                            flex-column
                            justify-content-between
                            col-xl-3 col-md-4
                          "
                        >
                          <label
                            for="field-cvv"
                            class="form__label"
                            style="margin-bottom: 9px !important"
                            >CCV
                            <span class="err-msg" v-if="errors.ccCCV"
                              >*Required</span
                            ></label
                          >
                          <input
                            type="number"
                            class="field"
                            id="field-cvv"
                            placeholder="000"
                            v-model="ccInfo.CCV"
                            v-bind:class="{ error: errors.ccCCV }"
                          />
                        </div>
                        <div
                          class="
                            form-group
                            flex-column
                            justify-content-between
                            col-xl-6 col-md-4
                            p-l-1
                          "
                          v-if="ccTypes.length"
                        >
                          <label for="field-cvv" class="form__label"
                            >Acceptable Credit Cards</label
                          >
                          <span
                            v-for="item in ccTypes"
                            :key="item.methodid"
                            class="icon-wrap"
                          >
                            <i v-bind:class="item.icon"></i
                          ></span>
                        </div>
                        <!-- /.form-group col-md-6 -->
                      </div>
                      <!-- /.form-row -->
                    </div>
                    <!-- /.form-checkout -->
                  </div>
                  <!-- /.box__content -->
                </div>
                <!-- /.box-form -->
                <div class="tab__head">
                  <h5>
                    Billing Information
                    <md-checkbox
                      v-model="sameAsProfile"
                      :disabled="
                        !profile.memberAddress1 ||
                          !profile.memberCity ||
                          !profile.memberZip ||
                          !profile.memberState
                      "
                      >Same As Profile</md-checkbox
                    >
                  </h5>
                </div>
                <!-- /.tab__head -->
                <div class="box-form">
                  <div class="box__content">
                    <div
                      class="form-frame form-frame--alt"
                      v-if="sameAsProfile"
                    >
                      <p class="p-wrap">
                        <span class="p-title form__label">Address: </span
                        ><span class="p-value">{{
                          profile.memberAddress1
                        }}</span>
                      </p>
                      <p class="p-wrap" v-if="profile.memberAddress2">
                        <span class="p-title form__label">Address 2: </span
                        ><span class="p-value">{{
                          profile.memberAddress2
                        }}</span>
                      </p>
                      <p class="p-wrap">
                        <span class="p-title form__label">City: </span
                        ><span class="p-value">{{ profile.memberCity }}</span>
                      </p>
                      <p class="p-wrap">
                        <span class="p-title form__label">State: </span
                        ><span class="p-value">{{ profile.memberState }}</span>
                      </p>
                      <p class="p-wrap">
                        <span class="p-title form__label">Postal Code: </span
                        ><span class="p-value">{{ profile.memberZip }}</span>
                      </p>
                      <p class="p-wrap">
                        <span class="p-title form__label">Phone: </span
                        ><span class="p-value">{{ profile.memberPhone }}</span>
                      </p>
                    </div>
                    <div
                      class="form-frame form-frame--alt"
                      v-if="!sameAsProfile"
                    >
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="field-address-4" class="form__label"
                            >Address1
                            <span class="err-msg" v-if="errors.bAddress1"
                              >*Required</span
                            ></label
                          >
                          <input
                            type="text"
                            class="field"
                            id="field-address-4"
                            placeholder
                            v-model="billingInfo.Address1"
                            v-bind:class="{ error: errors.bAddress1 }"
                          />
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="field-address-5" class="form__label"
                            >Address2</label
                          >
                          <input
                            type="text"
                            class="field"
                            id="field-address-5"
                            placeholder
                            v-model="billingInfo.Address2"
                          />
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->
                      <div class="form-row">
                        <div class="form-group col-lg-6">
                          <label for="field-city-3" class="form__label"
                            >City
                            <span class="err-msg" v-if="errors.bCity"
                              >*Required</span
                            ></label
                          >
                          <input
                            type="text"
                            class="field"
                            id="field-city-3"
                            placeholder
                            v-model="billingInfo.City"
                            v-bind:class="{ error: errors.bCity }"
                          />
                        </div>
                        <!-- /.form-group col-md-6 -->
                        <div class="form-group col-lg-2 col-md-6">
                          <label for="field-state-3" class="form__label"
                            >State
                            <span class="err-msg" v-if="errors.bState"
                              >*Required</span
                            ></label
                          >
                          <input
                            type="text"
                            class="field"
                            id="field-state-3"
                            v-model="billingInfo.State"
                            v-bind:class="{ error: errors.bState }"
                          />
                          <!-- <div class="select select--grey">
                            <select
                              id="field-state-3"
                              v-model="billingInfo.State"
                              v-bind:class="{ error: errors.bState }"
                            >
                              <option value>Select</option>
                              <option
                                :value="state.abbreviation"
                                v-for="state in states"
                                :key="state.abbreviation"
                              >
                                {{ state.abbreviation }}
                              </option>
                            </select>
                          </div> -->
                          <!-- /.select -->
                        </div>
                        <!-- /.form-group col-md-2 -->
                        <div class="form-group col-lg-4 col-md-6">
                          <label for="field-code-3" class="form__label"
                            >Postal Code
                            <span class="err-msg" v-if="errors.bPostalCode"
                              >*Required</span
                            ></label
                          >
                          <input
                            type="text"
                            class="field"
                            id="field-code-3"
                            placeholder
                            v-model="billingInfo.PostalCode"
                            v-bind:class="{ error: errors.bPostalCode }"
                          />
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <label for="field-phone-3" class="form__label"
                            >Phone</label
                          >
                          <input
                            type="number"
                            class="field"
                            id="field-phone-3"
                            placeholder
                            v-model="billingInfo.Phone"
                          />
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->
                    </div>
                    <!-- /.form-frame form-frame-/-alt -->
                  </div>
                  <!-- /.box__content -->
                </div>
              </div>
              <!-- pay later alligator -->
              <div
                class="tab"
                v-if="selPaymentMethod === 3"
                style="display: none"
              >
                <div class="tab__head">
                  <h5>Pay Later Information</h5>
                </div>
                <div class="box-form">
                  <p>
                    AFTER clicking the "Place Your Order" button at the bottom
                    right corner
                  </p>
                  <p v-html="settings && settings.payLaterText"></p>
                </div>
              </div>
              <!-- email CONFITMATION -->
              <div class="tab" v-if="selPaymentMethod !== 2">
                <div class="tab__head">
                  <h5>Email Receipt To</h5>
                </div>
                <!-- /.tab__head -->
                <div class="box-form">
                  <div class="box__content">
                    <label for="field-name-1" class="form__label"
                      >Email Address</label
                    >
                    <input
                      type="email"
                      class="field"
                      id="field-name-1"
                      placeholder="Email"
                      v-model="emailToConfirm"
                    />
                  </div>
                </div>
                <!-- /.box-form -->
              </div>
              <!-- /.tab -->
            </div>
            <!-- /.tabs__body -->
          </div>
          <!-- /.tabs -->
        </div>
        <!-- /.content__head -->
      </div>
      <!-- /.content -->
    </div>
    <!-- /.col-md-7 -->
    <div class="col-md-5" v-bind:class="{ 'col-md-12': isTablet }">
      <div
        class="sidebar"
        style="background-color: #fff"
        v-bind:class="{ 'sidebar-relative': isTablet }"
      >
        <CartPage />
        <div
          class="
            sidebar__actions
            d-flex
            flex-wrap
            justify-content-between
            align-items-center
          "
          v-bind:class="{
            'fixed-side-actions ': !isMobile,
            no_padding: isMobile,
          }"
        >
          <!-- <router-link to="/content/promo">Go Back</router-link> -->
          <md-button class="btn-grey btn-grey-long" @click="goBack()"
            >Back</md-button
          >
          <md-button
            class="btn-green"
            @click="
              disablePayment = true;
              validatePayment(ccInfo, billingInfo);
            "
            :disabled="disablePayment"
            >Place Your Order</md-button
          >
        </div>
        <!-- /.sidebar__actions -->
      </div>
    </div>
    <!-- fees to cover -->
    <div>
      <md-dialog-confirm
        :md-active.sync="showPromptFees"
        class="prompt_dialog"
        :md-title="settings.feeTitle"
        :md-content="feeText"
        md-confirm-text="Yes, I want To Help"
        md-cancel-text="No, Place My Order"
        @md-cancel="onCancel()"
        @md-confirm="addFeeToCart()"
        :md-click-outside-to-close="false"
      />
    </div>
  </div>
  <!-- /.row -->
</template>
<script>
import CartPage from "../components/CartPage.vue";
import json from "../assets/states.json";
import moment from "moment";
import currencyFilter from "../shared/currency-filter";
import { showErrorAlert } from "../helpers";

export default {
  name: "PaymentPage",
  components: { CartPage },
  filters: {
    currency: currencyFilter,
  },
  data: function() {
    return {
      feeText: "",
      showPromptFees: false,
      paymentMethods: [
        {
          id: 1,
          label: "Credit Card",
          value: "cc",
          icon: "fal fa-credit-card",
        },
        { id: 2, label: "PayPal", value: "paypal", icon: "fab fa-cc-paypal" },
        {
          id: 3,
          label: "Pay Later",
          value: "BillMe",
          icon: "far fa-money-check",
        },
        {
          id: 4,
          label: "Pay 0",
          value: "BillMe",
          icon: "far fa-money-check",
        },
      ],
      selPaymentMethod: 1,
      ccInfo: {
        FirstName: "",
        LastName: "",
        CardNumber: "",
        ExpYear: "",
        ExpMonth: "",
        CCV: null,
      },
      billingInfo: {
        Address1: "",
        Address2: "",
        City: "",
        State: "",
        PostalCode: "",
        Phone: "",
      },
      emailToConfirm: "",
      states: json,
      sameAsProfile: false,
      errors: {
        ccFirstName: false,
        ccLastName: false,
        ccCardNumber: false,
        ccExpYear: false,
        ccExpMonth: false,
        ccCCv: false,
        bAddress1: false,
        bCity: false,
        bState: false,
        bPostalCode: false,
      },
      lockPayment: true,
      disablePayment: false,
      pay_info: {},
    };
  },
  watch: {
    selPaymentMethod: function() {
      this.disablePayment = false;
      console.log("this.disablePayment ", this.disablePayment);
    },
    sameAsProfile: function(val) {
      if (val) {
        this.errors.bAddress1 = false;
        this.errors.bCity = false;
        this.errors.bPostalCode = false;
        this.errors.bState = false;
        this.billingInfo = {
          Address1: "",
          Address2: "",
          City: "",
          State: "",
          PostalCode: "",
          Phone: "",
        };
      }
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    isTablet() {
      return this.$store.getters.isTablet;
    },
    months() {
      let m_arr = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ];
      return m_arr;
    },
    years() {
      let now = moment().format();
      let tenyears = moment(now).add(10, "years");
      let m_arr = [];
      while (moment(now).isBefore(tenyears)) {
        m_arr.push(moment(now).format("YYYY"));
        now = moment(now).add(1, "year");
      }
      return m_arr;
    },
    settings() {
      return this.$store.state.settings[0];
    },
    profile() {
      return this.$store.state.userProfile[0];
    },
    order() {
      return this.$store.state.finalOrder;
    },
    discounts() {
      return this.$store.state.discounts;
    },
    localDeliveryPricing() {
      return this.$store.state.localDeliveryPricing;
    },
    totalPrice() {
      let price = 0;
      console.log(
        "this.$store.state.finalOrder.totalDiscountedPrice ,this.$store.state.finalOrder.totalPrice",
        this.$store.state.finalOrder.totalDiscountedPrice,
        this.$store.state.finalOrder.totalPrice
      );
      if (this.$store.state.finalOrder.totalDiscountedPrice > 0) {
        price = this.$store.state.finalOrder.totalDiscountedPrice;
        console.log("ppppp 1 ", price);
      } else {
        price = this.$store.state.finalOrder.totalPrice;
        console.log("ppppp 2 ", price);
      }
      setTimeout(() => {
        if (price === 0) {
          console.log("resetting payment method ", price);
          //  this.selPaymentMethod = 4; // to come back and add xstr names
        }
      }, 5000);
      console.log(
        "this.$store.state.finalOrder from total price ",
        this.$store.state.finalOrder,
        price
      );
      return price;
    },
    ccTypes() {
      console.log(
        "this.$store.state.paymentMethods",
        this.$store.state.paymentMethods
      );
      let obj = this.$store.state.paymentMethods;
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].methodCode === "v") {
          obj[i].icon = "fab fa-cc-visa";
        } else if (obj[i].methodCode === "m") {
          obj[i].icon = "fab fa-cc-mastercard";
        } else if (obj[i].methodCode === "a") {
          obj[i].icon = "fab fa-cc-amex";
        } else if (obj[i].methodCode === "d") {
          obj[i].icon = "fab fa-cc-discover";
        } else {
          obj[i].icon = "fal fa-credit-card";
        }
      }
      return this.$store.state.paymentMethods;
    },
  },
  methods: {
    onCancel: async function() {
      console.log("Person dont want to donate fees ");
      this.showPromptFees = false;
      await this.$store.dispatch("placeOrder", this.pay_info);
    },
    showFeePrompt: function(pay_info) {
      console.log(" -=--=- pay info -=-=--", pay_info);
      let fee = 0;
      if (this.settings.creditCardPercent > 0) {
        fee =
          (pay_info.total * this.settings.creditCardPercent) / 100 +
          this.settings.perTransactionFee;
        fee = parseFloat(fee).toFixed(2);
      }
      this.feeText =
        this.settings.feeText +
        " " +
        this.settings.symbol +
        fee.toString() +
        " ?";
      this.showPromptFees = true;
    },

    async updateUpsellFee(fees) {
      try {
        let obj = {
          itemId: 666,
          price: JSON.parse(fees),
          quantity: 1,
          description: this.settings.feeDesc,
          shipTo: "",
          message: "",
        };
        await this.$store.dispatch("updateUpsell", { data: obj, param: "add" });
        await this.$store.dispatch("placeOrder", this.pay_info);
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },

    addFeeToCart() {
      this.$store.commit("fillAuxPayment", this.pay_info);

      let fee = 0;
      if (this.settings.creditCardPercent > 0) {
        fee =
          (this.pay_info.total * this.settings.creditCardPercent) / 100 +
          this.settings.perTransactionFee;
      }
      this.pay_info.total = this.pay_info.total + Number(fee);
      this.updateUpsellFee(fee).then();
    },
    goBack: function() {
      let addOptions = this.$store.getters.addOptions;
      if (!addOptions) {
        this.$router.push("/content/list").catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      } else {
        this.$router.push("/content/promo").catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      }
    },
    checkForLocalPrice: function(price, zip, shipoption) {
      console.log(price, zip, shipoption, this.settings.organizationId);
      let data = this.localDeliveryPricing;
      let p = price;
      for (let i = 0; i < data.length; i++) {
        if (
          data[i].enabled &&
          data[i].localDeliveryPrice &&
          data[i].zipCode.toString().trim() === zip.toString().trim()
        ) {
          if (this.settings.organizationId === 371 && shipoption === 5) {
            p = 15;
          } else {
            p = Number(data[i].localDeliveryPrice);
          }
        }
      }
      return p;
    },
    checkForShippingOptions: function(price, shipoption) {
      let options = this.$store.state.shippingCustomOptions;
      let p = price;
      if (options.length) {
        let price = options.filter((data) => shipoption === data.id);
        if (price.length) {
          p = price[0].price;
        }
      }
      return p;
    },
    async updateOrderItems() {
      try {
        let data = this.$store.state.cart.additionalBaskets;
        let sendout = this.$store.state.organizationInfo[0].sSendoutprice;
        for (let i = 0; i < data.length; i++) {
          data[i].Price = sendout;
          data[i].value = sendout;
          data[i].ApiID = 2;
          data[i].Price = this.checkForShippingOptions(
            data[i].Price,
            data[i].shippingOptionId
          );
          data[i].Price = this.checkForLocalPrice(
            data[i].Price,
            data[i].zip.trim(),
            data[i].shippingOptionId
          );
          let obj = {
            itemId: data[i].ApiID,
            price: data[i].Price,
            quantity: 1,
            description: "Shipping Gift Basket to",
            shipTo: data[i].recipient.trim(),
            message: data[i].message,
          };
          await this.$store.dispatch("updateUpsell", {
            data: obj,
            param: "add",
          });
        }
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },
    GetCardType: function(number) {
      // visa
      var re = new RegExp("^4");
      if (number.match(re) != null) return "Visa";
      // Mastercard
      // Updated for Mastercard 2017 BINs expansion
      if (
        /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
          number
        )
      )
        return "Mastercard";
      // AMEX
      re = new RegExp("^3[47]");
      if (number.match(re) != null) return "AMEX";
      // Discover
      re = new RegExp(
        "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)"
      );
      if (number.match(re) != null) return "Discover";
      // Diners
      re = new RegExp("^36");
      if (number.match(re) != null) return "Diners";
      // Diners - Carte Blanche
      re = new RegExp("^30[0-5]");
      if (number.match(re) != null) return "Diners - Carte Blanche";
      // JCB
      re = new RegExp("^35(2[89]|[3-8][0-9])");
      if (number.match(re) != null) return "JCB";
      // Visa Electron
      re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
      if (number.match(re) != null) return "Visa Electron";
      return "";
    },
    checkCardIfSupported: function(code) {
      let approved = false;
      for (let i = 0; i < this.ccTypes.length; i++) {
        if (this.ccTypes[i].methodCode === code) {
          approved = true;
          return approved;
        }
      }
      return approved;
    },
    checkValidation(data) {
      let val = false;
      for (let i in data) {
        if (data[i]) {
          val = true;
          return val;
        }
      }
      return val;
    },
    validatePayment(cc, binfo) {
      console.log("this.$store.state.cart ", this.$store.state.cart);
      // bill me later
      if (
        this.selPaymentMethod === 3 ||
        this.selPaymentMethod === 2 ||
        this.selPaymentMethod === 4
      ) {
        let pay_info = {
          paymentType: "",
          paymentMethod: "",
          firstName: "",
          lastName: "",
          creditCardNumber: "",
          cardCode: "",
          cardExpirationMonth: "",
          cardExpirationYear: "",
          billAddress1: "",
          billAddress2: "",
          billCity: "",
          billState: "",
          billZip: "",
          total: "",
          emailTo: this.emailToConfirm,
          tempCode: this.$store.state.tempCode,
          phone: "",
          specialInstructions: "",
          discountName: "",
          discountPrice: 0,
          reciprocity: this.profile?.reciprocity,
        };
        console.log(
          "this.$store.state.finalOrder ",
          this.$store.state.finalOrder
        );
        if (this.$store.state.finalOrder.totalDiscountedPrice > 0) {
          pay_info.total = this.$store.state.finalOrder.totalDiscountedPrice;
          pay_info.discountName = this.discounts[0].description;
          pay_info.discountPrice = -this.order.disc;
          if (this.settings.feeActive && this.settings.feeRequired) {
            let fees =
              this.$store.state.finalOrder.processFee +
              this.$store.state.finalOrder.perTransactionFee;

            pay_info.total =
              this.$store.state.finalOrder.totalDiscountedPrice + fees;
            this.updateUpsell(fees).then();
          }
        } else {
          pay_info.total = this.$store.state.finalOrder.totalPrice;
          if (this.settings.feeActive && this.settings.feeRequired) {
            let fees =
              this.$store.state.finalOrder.processFee +
              this.$store.state.finalOrder.perTransactionFee;
            pay_info.total = this.$store.state.finalOrder.totalPrice + fees;
            this.updateUpsell(fees).then();
          }
        }
        if (this.selPaymentMethod === 3 || this.selPaymentMethod === 4) {
          pay_info.paymentMethod = "BillMe";
        } else {
          pay_info.paymentMethod = "PayPal";
          pay_info.paymentType = "PayPal";
        }
        console.log("pay info ", pay_info);
        this.confirmPayment(pay_info).then();
      }
      // credit card
      else if (this.selPaymentMethod === 1) {
        if (!cc.FirstName) {
          this.errors.ccFirstName = true;
        } else {
          this.errors.ccFirstName = false;
        }
        if (!cc.LastName) {
          this.errors.ccLastName = true;
        } else {
          this.errors.ccLastName = false;
        }
        if (!cc.ExpMonth) {
          this.errors.ccExpMonth = true;
        } else {
          this.errors.ccExpMonth = false;
        }
        if (!cc.ExpYear) {
          this.errors.ccExpYear = true;
        } else {
          this.errors.ccExpYear = false;
        }
        if (!cc.CardNumber) {
          this.errors.ccCardNumber = true;
        } else {
          this.errors.ccCardNumber = false;
        }
        if (!cc.CCV) {
          this.errors.ccCCV = true;
        } else {
          this.errors.ccCCV = false;
        }
        if (!this.sameAsProfile) {
          if (!binfo.Address1) {
            this.errors.bAddress1 = true;
          } else {
            this.errors.bAddress1 = false;
          }
          if (!binfo.City) {
            this.errors.bCity = true;
          } else {
            this.errors.bCity = false;
          }
          if (!binfo.PostalCode) {
            this.errors.bPostalCode = true;
          } else {
            this.errors.bPostalCode = false;
          }
          if (!binfo.State) {
            this.errors.bState = true;
          } else {
            this.errors.bState = false;
          }
        }
        this.lockPayment = this.checkValidation(this.errors);
        console.log(this.discounts, this.order, this.lockPayment);
        if (!this.lockPayment) {
          let pay_info = {
            paymentType: "",
            paymentMethod: "",
            firstName: cc.LastName,
            lastName: cc.FirstName,
            creditCardNumber: cc.CardNumber,
            cardCode: cc.CCV,
            cardExpirationMonth: cc.ExpMonth,
            cardExpirationYear: cc.ExpYear,
            billAddress1: binfo.Address1,
            billAddress2: binfo.Address2,
            billCity: binfo.City,
            billState: binfo.State,
            billZip: binfo.PostalCode,
            total: "",
            emailTo: this.emailToConfirm,
            tempCode: this.$store.state.tempCode,
            phone: binfo.Phone,
            specialInstructions: "",
            discountName: "",
            discountPrice: 0,
            reciprocity: this.profile?.reciprocity,
          };
          if (this.sameAsProfile) {
            pay_info.billAddress1 = this.profile?.memberAddress1;
            pay_info.billAddress2 = this.profile?.memberAddress2;
            pay_info.billCity = this.profile?.memberCity;
            pay_info.billZip = this.profile?.memberZip;
            pay_info.billState = this.profile?.memberState;
            pay_info.phone = this.profile?.memberPhone;
          }
          if (this.$store.state.finalOrder.totalDiscountedPrice > 0) {
            pay_info.total = this.$store.state.finalOrder.totalDiscountedPrice;
            pay_info.discountName = this.discounts[0].description;
            pay_info.discountPrice = -this.order.disc;
            if (this.settings.feeActive && !this.settings.feeRequired) {
              let fees =
                this.$store.state.finalOrder.processFee +
                this.$store.state.finalOrder.perTransactionFee;
              pay_info.total =
                this.$store.state.finalOrder.totalDiscountedPrice + fees;
              this.updateUpsell(fees).then();
            }
          } else {
            pay_info.total = this.$store.state.finalOrder.totalPrice;
            if (this.settings.feeActive && this.settings.feeRequired) {
              let fees =
                this.$store.state.finalOrder.processFee +
                this.$store.state.finalOrder.perTransactionFee;
              pay_info.total = this.$store.state.finalOrder.totalPrice + fees;
              this.updateUpsell(fees).then();
            }
          }
          if (this.selPaymentMethod === 1 && cc.CardNumber.length) {
            let card = {};
            card.type = this.GetCardType(cc.CardNumber);
            card.code = card.type.charAt(0).toLowerCase();
            card.supported = this.checkCardIfSupported(card.code);
            if (!card.supported) {
              this.$store.commit("showToast", {
                message: "Credit Card Is Not Supported",
                position: "bottom",
                type: "error",
              });
              this.errors.ccCardNumber = true;
              this.lockPayment = true;
            } else {
              pay_info.paymentType = card.type;
              pay_info.paymentMethod = card.code;
            }
          }
          console.log("pay info", pay_info);
          this.confirmPayment(pay_info).then();
        }
      }
      this.disablePayment = false;
      // console.log("cc ", cc, "info ", binfo);
    },
    async updateUpsell(fees) {
      try {
        let obj = {
          itemId: 666,
          price: fees,
          quantity: 1,
          description: this.settings.feeDesc,
          shipTo: "",
          message: "",
        };
        await this.$store.dispatch("updateUpsell", { data: obj, param: "add" });
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },
    checkCart(data) {
      let empt_cart = false;

			console.log('all in the cart here'.data);
      if (
        !data.additional.length &&
        !data.additionalBaskets.length &&
        !data.donations.length &&
        !data.list.length &&
        !data.orderItems.length &&
        !data.promo.length &&
        !data.upsell.length
      ) {
        empt_cart = true;
      }
      return empt_cart;
    },
    async confirmPayment(pay_info) {
      try {
        this.pay_info = {};
        let cart = this.$store.state.cart;
        // check cart if not empty
        let empty_cart = this.checkCart(cart);
        if (!empty_cart) {
          if (pay_info.total < 0) {
            this.$store.commit("showToast", {
              message:
                "Total Order Cannot Be 0, Please Check Your Shopping Card!",
              position: "bottom",
              type: "error",
            });
          } else if (pay_info.total === 0) {
            this.selPaymentMethod = 4;
            this.$store.state.finalOrder.emailToConfirm = this.emailToConfirm;
            this.$store.state.finalOrder.selPaymentMethod = this.selPaymentMethod;
            if (this.selPaymentMethod === 3) {
              this.$store.state.finalOrder.payLaterText = this.settings.payLaterText;
            }
            if (this.discounts.length) {
              let obj = {
                itemId: -100,
                price: -this.$store.state.finalOrder.disc,
                quantity: 1,
                description: this.discounts[0].description,
                shipTo: "",
                message: "",
              };
              await this.$store.dispatch("updateUpsell", {
                data: obj,
                param: "add-notreload",
              });
            }
            if (pay_info.reciprocity === 1 || pay_info.reciprocity === true) {
              pay_info.reciprocity = true;
            } else {
              pay_info.reciprocity = false;
            }
            await this.$store.dispatch("placeOrder", pay_info);
          } else {
            this.$store.state.finalOrder.emailToConfirm = this.emailToConfirm;
            this.$store.state.finalOrder.selPaymentMethod = this.selPaymentMethod;
            if (this.selPaymentMethod === 3) {
              this.$store.state.finalOrder.payLaterText = this.settings.payLaterText;
            }
            if (this.discounts.length) {
              let obj = {
                itemId: -100,
                price: -this.$store.state.finalOrder.disc,
                quantity: 1,
                description: this.discounts[0].description,
                shipTo: "",
                message: "",
              };
              await this.$store.dispatch("updateUpsell", {
                data: obj,
                param: "add-notreload",
              });
            }
            if (pay_info.reciprocity === 1 || pay_info.reciprocity === true) {
              pay_info.reciprocity = true;
            } else {
              pay_info.reciprocity = false;
            }
            //  if organization has fee active but not required , show dialog to offer fee, otherwise just place order
            this.pay_info = pay_info;
            if (this.settings.feeActive && !this.settings.feeRequired) {
              this.showFeePrompt(pay_info);
              console.log("Calling Fee Dialog .....");
            } else {
              console.log("Placing Order ... with no fee");
              await this.$store.dispatch("placeOrder", pay_info);
            }
          }
        } else {
          // if cart is empty
          this.$store.commit("showToast", {
            message: "Your Cart is Empty , Please Check Your Shopping Card!",
            position: "bottom",
            type: "error",
          });
        }
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },
  },
  created() {
    this.emailToConfirm = this.$store.state.userProfile[0]?.memberPrimaryEmail;
    window.scrollTo(0, 0);
    console.log("this.$store.state.finalOrder ", this.$store.state.finalOrder);
    this.updateOrderItems().then();
    if (!this.ccTypes.length) {
      if (this.settings?.payPal) {
        this.selPaymentMethod = 2;
      } else {
        this.selPaymentMethod = 3;
      }
    }
  },
};
</script>
<style scoped>
.md-dialog /deep/ .md-dialog-title {
  margin-bottom: 20px;
  padding: 12px 24px 12px;
  background: #ff607f;
  color: white;
}
.no_padding {
  padding: 0 !important;
}
.box-form:after {
  width: 100% !important;
  background-color: #ff607f;
}
.btn-green {
  text-transform: capitalize !important;
  padding: 1em;
  min-height: 45px;
}
.form__label {
  text-align: left;
  padding-left: 0;
  width: 100%;
}
.form-frame--alt .form__label {
  padding-left: 0;
}
.fa-credit-card,
.fa-cc-paypal,
.fa-money-check {
  font-size: 1.2em;
  padding-left: 0.5em;
  color: #ff607f;
}
.icon-wrap {
  display: inline-block;
  font-size: 3em;
  padding-right: 0.5em;
  padding-top: 0.2em;
}
.fa-cc-visa {
  color: #0053a1;
}
.fa-cc-mastercard {
  color: #f79f14;
}
.fa-cc-amex {
  color: #258ae8;
}
.fa-cc-discover {
  color: #9ca0a6;
}
.md-checkbox .md-checkbox-label {
  height: 20px;
  padding-left: 16px;
  position: relative;
  line-height: 26px;
  margin: 0;
}
.md-checkbox {
  margin: 0 1em;
}
.md-checkbox /deep/ .md-checkbox-label {
  margin: 0 im !important;
  line-height: 26px;
}
.p-wrap {
  display: inline-block;
  width: 50%;
}
.p-value {
  padding-left: 10px;
  font-weight: 500;
  font-size: 15px;
}
.err-msg {
  color: red;
  font-weight: 600;
  font-size: 11px;
  float: right;
}
.error {
  border-color: red !important;
}
.select-field {
  width: 100%;
  height: 42px;
  border-radius: 0.25rem;
  border: 1px solid #e7e7e7;
  padding: 0 10px;
}
.sel-wrap {
  display: inline-block;
  width: 50%;
  padding: 0 5px 0 0;
}
.sel-wrap-mobile {
  display: block;
  width: 100%;
  padding: 0 5px 0 0;
}
.sidebar-relative {
  position: relative;
}
/deep/.md-radio.md-theme-default.md-checked .md-radio-container {
  border-color: #ff607f;
}
/deep/.md-radio.md-theme-default.md-checked .md-radio-container:after {
  background-color: #ff607f;
}
/* .p-title{min-width: 100px;display:inline-block;} */

/deep/ .md-dialog-actions button:first-child {
  background: #ff607f;
  padding-right: 1em;
  padding-left: 1em;
  color: white;
}
/deep/ .md-dialog-actions button:nth-child(2) {
  background: #4bbe56;
  padding-right: 1em;
  padding-left: 1em;
  color: white;
}
/deep/ .md-dialog-actions {
  justify-content: center;
}
</style>
